import { baseApi } from './baseApi';
import { buildListQueryParams } from '../utils/pagination';
import { runOptimisticCachedQueryPatches } from './queryCacheUtils';

const isFormData = (value) =>
  typeof FormData !== 'undefined' && value instanceof FormData;

export const outletApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getOutlets: builder.query({
      query: (args = {}) => ({
        url: '/api/outlets',
        params: buildListQueryParams(args),
      }),
      providesTags: ['Outlets'],
    }),
    createOutlet: builder.mutation({
      query: (outlet) => ({
        url: '/api/outlets',
        method: 'POST',
        body: isFormData(outlet) ? outlet : { outlet },
      }),
      invalidatesTags: ['Outlets'],
    }),
    updateOutlet: builder.mutation({
      query: ({ id, outlet }) => ({
        url: `/api/outlets/${id}`,
        method: 'PUT',
        body: isFormData(outlet) ? outlet : { outlet },
      }),
      invalidatesTags: ['Outlets'],
    }),
    updateOutletStatus: builder.mutation({
      query: ({ id, status }) => ({
        url: `/api/outlets/${id}/update_status`,
        method: 'PATCH',
        body: { status },
      }),
      async onQueryStarted({ id, status }, { dispatch, getState, queryFulfilled }) {
        await runOptimisticCachedQueryPatches({
          dispatch,
          getState,
          queryFulfilled,
          endpointName: 'getOutlets',
          updateDraft: (draft) => {
            const list = draft?.data;
            if (!Array.isArray(list)) return;
            const row = list.find((o) => Number(o.id) === Number(id));
            if (row) row.status = status;
          },
        });
      },
    }),
  }),
});

export const {
  useGetOutletsQuery,
  useCreateOutletMutation,
  useUpdateOutletMutation,
  useUpdateOutletStatusMutation,
} = outletApi;

